import { read, utils } from 'xlsx';//for sheet.JS
import { useRef, useState, useEffect } from 'react';// for hooks and mount loading
import React from 'react';// for react
import * as XLSX from 'xlsx'

import axios from 'axios';
import 'semantic-ui-css/semantic.min.css'
import {BrowserRouter as Router,Routes, Route, Link } from 'react-router-dom';

 










const handleSubmit = async (e) => {
    e.preventDefault()//dont reload the page
    
}


function TillReport(){
    const [Name,setName] = useState('') // using hooks so they can be used in the form 
    const [post,setPosted] = useState('');
    const [Entries,setEntries] = useState()//Entry Hook
    const [submit, setSubmit] = useState(false)
    const [oysterTill, setOysterTill] = useState(0);
    const [oysterReport, setOysterReport] = useState(0);
    const [paypointTill, setPaypointTill] = useState(0);
    const [paypointReport, setPaypointReport] = useState(0);
    const [lottocardTill, setLottocardTill] = useState(0);
    const [lottocardReport, setLottocardReport] = useState(0);
    const [lottomachineReport, setLottomachineReport] = useState(0);
    const [lottomachineTill, setLottomachineTill] = useState(0);
    const [phonecardTill, setPhonecardTill] = useState(0);
    const [phonecardReport, setPhonecardReport] = useState(0);

    const [closing,setClosing] = useState(0)
    const [lottocardDiff, setlottocardDiff] = useState()
    const[paypointDiff,setpaypointDiff] = useState()
    const [oysterDiff, setoysterDiff] = useState()
    const [lottomachineDiff, setlottomachineDiff] = useState();
    const [phonecardDiff, setphonecardDiff] = useState(); 

    

    
    
    function convertJSON({oysterTill, oysterReport, paypointTill, paypointReport,lottomachineTill,  lottocardTill,lottocardReport, lottomachineReport, phonecardTill, phonecardReport}){//using props
        let templottocardDiff = parseFloat(lottocardTill) - parseFloat(lottocardReport)
        setlottocardDiff(templottocardDiff)// setting lottocard differences
        let tempoysterDiff = parseFloat(oysterTill)-parseFloat(oysterReport)
        setoysterDiff(tempoysterDiff)//setting oyster differences
        let temppaypointDiff= parseFloat(paypointTill) - parseFloat(paypointReport)
        setpaypointDiff(temppaypointDiff)//setting paypoint differences
        let templottomachineDiff = parseFloat(lottomachineTill) - parseFloat(lottomachineReport)
        setlottomachineDiff(templottomachineDiff)//setting lotto machine differences

        let tempphonecardDiff = parseFloat(phonecardTill) - parseFloat(phonecardReport)
        setphonecardDiff(tempphonecardDiff)//setting phonecard differences

      
        //carry on for rest and add to JSON  



        
        const JSONobj = {
          oysterTill: oysterTill,
          oysterReport: oysterReport,
          oysterDiff: tempoysterDiff,
          paypointTill: paypointTill,
          paypointReport: paypointReport,
          paypointDiff: paypointDiff,
          lottocardTill: lottocardTill,
          lottocardReport: lottocardReport,
          lottocardDiff: lottocardDiff,
          lottomachineTill: lottomachineTill,
          lottomachineReport: lottomachineReport,
          lottomachineDiff: lottomachineDiff,
          phonecardTill: phonecardTill,
          phonecardReport: phonecardReport,
          phonecardDiff: phonecardDiff
        }
        console.log(JSONobj)// checking the correct object is being parse

        setSubmit(!submit)//setting submit field to True
        setEntries(JSONobj)//Setting JSON to a hook so it can be used globally
        // +', "Money":'+Money
        





        

        
        
        
    }


    function Submit(){
        axios.post('https://sheet.best/api/sheets/6fda76c8-775a-4e52-94b0-5bd51ad42c1a', Entries)
        .then(response => {
          console.log(response);
          setPosted('Success!')
        })

    }

    

    return(
        <form onSubmit={handleSubmit} >
          <div className="entireForm">
              <div className="labelWrapper">
                <label htmlFor="name">Name:</label>
                <input 
                 type="text" 
                 id="name"
                 className="typein__box"
                 onChange = {(e)=> setName(e.target.value)} 
                //  using a imaginary variable to setName when changed
                 value = {Name}
                 required
                />
               
              <div className="everyForm">
               <div className="firstTotal">
                

               <label htmlFor="oysterTill">Oyster Till:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="oysterTill"
                  onChange={(e) => setOysterTill(e.target.value)}
                  value={oysterTill}
                />

                <label htmlFor="oysterReport">Oyster Report:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="oysterReport"
                  onChange={(e) => setOysterReport(e.target.value)}
                  value={oysterReport}
                />

                <label htmlFor="paypointTill">Paypoint Till:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="paypointTill"
                  onChange={(e) => setPaypointTill(e.target.value)}
                  value={paypointTill}
                />

                <label htmlFor="paypointReport">Paypoint Report:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="paypointReport"
                  onChange={(e) => setPaypointReport(e.target.value)}
                  value={paypointReport}
                />

                <label htmlFor="lottocardTill">Lottocard Till:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="lottocardTill"
                  onChange={(e) => setLottocardTill(e.target.value)}
                  value={lottocardTill}
                />

                <label htmlFor="lottocardReport">Lottocard Report:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="lottocardReport"
                  onChange={(e) => setLottocardReport(e.target.value)}
                  value={lottocardReport}
                />
                <label htmlFor="lottomachineTill">Lottomachine Till:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="lottomachineTill"
                  onChange={(e) => setLottomachineTill(e.target.value)}
                  value={lottomachineTill}
                />


                <label htmlFor="lottomachineReport">Lottomachine Report:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="lottomachineReport"
                  onChange={(e) => setLottomachineReport(e.target.value)}
                  value={lottomachineReport}
                />

                <label htmlFor="phonecardTill">Phonecard Till:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="phonecardTill"
                  onChange={(e) => setPhonecardTill(e.target.value)}
                  value={phonecardTill}
                />

                <label htmlFor="phonecardReport">Phonecard Report:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="phonecardReport"
                  onChange={(e) => setPhonecardReport(e.target.value)}
                  value={phonecardReport}
                />

                
     
                </div>



                
                
                
                
                
                <button className="button-10" onClick={() => convertJSON({oysterTill, oysterReport,lottomachineTill ,paypointTill, paypointReport, lottocardTill,lottocardReport, lottomachineReport, phonecardTill, phonecardReport})} >Submit</button>
                { submit ? <div className = "finalMessage"><p> Oyster Difference: { oysterDiff }</p><p> Paypoint Difference: { paypointDiff }</p> <p> Phone Card Difference: { phonecardDiff }</p><p> lottomachineDifference: { lottomachineDiff }</p><p> Lotto Card Difference: { lottocardDiff }</p><button className ="confirmButton button-10" onClick={() => Submit(Entries)}>Confirm Submit </button> <p className='green'>{post}</p>  <Link to="/">Complete Report</Link> </div>: <p className="smallFont">SugarTech 2023©</p>  }
              </div>
             </div>
          </div>
            </form>
    )


}


export default TillReport